import { ContentSC, HeaderContainerSC, ProjectNameSC, TitleSC } from "./styled";
import Pagination from "./components/Pagination";
import { useState } from "react";

export const Header = () => {
    const [currentPage, setCurrentPage] = useState(1);

    const handleChangePage = (val: number) => {
        setCurrentPage(val);
    };

    return (
        <HeaderContainerSC>
            <TitleSC>CourseMaker</TitleSC>
            <ContentSC>
                <ProjectNameSC>Relationship Course Scenes</ProjectNameSC>
                <Pagination
                    totalPages={50}
                    currentPage={currentPage}
                    onPageChange={handleChangePage}
                />
            </ContentSC>
        </HeaderContainerSC>
    );
};
